import { render, staticRenderFns } from "./CenteredLayout.vue?vue&type=template&id=1aa1f12e&"
import script from "./CenteredLayout.vue?vue&type=script&lang=js&"
export * from "./CenteredLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports